module.exports = __webpack_public_path__ + "static/media/arrow-up-right.09392b9a.svg";